import { render, staticRenderFns } from "./GhostPage.vue?vue&type=template&id=e2be6e66&scoped=true"
import script from "./GhostPage.vue?vue&type=script&lang=js"
export * from "./GhostPage.vue?vue&type=script&lang=js"
import style0 from "./GhostPage.vue?vue&type=style&index=0&id=e2be6e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2be6e66",
  null
  
)

export default component.exports